import AudioInputList from './AudioInputList/AudioInputList';
import AudioOutputList from './AudioOutputList/AudioOutputList';
import { DialogContent, Divider, Dialog, DialogActions, Theme, DialogTitle, Hidden } from '@material-ui/core';
import { Button } from '@dtsl/react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import VideoInputList from './VideoInputList/VideoInputList';
import MaxGalleryViewParticipants from './MaxGalleryViewParticipants/MaxGalleryViewParticipants';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: '600px',
    minHeight: '400px',
    [theme.breakpoints.down('xs')]: {
      width: 'calc(100vw - 32px)',
    },
    '& .inputSelect': {
      width: 'calc(100% - 35px)',
    },
    '& svg': {
      position: 'relative',
      bottom: '8px',
    },
  },
  paper: {
    [theme.breakpoints.down('xs')]: {
      margin: '16px',
    },
  },
  headline: {
    marginBottom: '1em',
  },
  listSection: {
    margin: '2em 0 0.8em',
    '&:first-child': {
      margin: '1em 0 2em 0',
    },
  },
}));

export default function DeviceSelectionDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} classes={{ paper: classes.paper }}>
      <DialogTitle disableTypography>
        <div className="sib-typo_heading-sm">{t('ROOM.SETTINGS')}</div>
      </DialogTitle>
      <Divider />
      <DialogContent className={classes.container}>
        <div className={classes.listSection}>
          <p className={clsx(classes.headline, 'sib-typo_text-body')}>{t('ROOM.CAM_SETTINGS')}</p>
          <VideoInputList />
        </div>
        <Divider />
        <div className={classes.listSection}>
          <p className={clsx(classes.headline, 'sib-typo_text-body')}>{t('ROOM.MIC_SETTINGS')}</p>
          <AudioInputList />
        </div>
        <div className={classes.listSection}>
          <AudioOutputList />
        </div>
        <Hidden smDown>
          <Divider />
          <div className={classes.listSection}>
            <p className={clsx(classes.headline, 'sib-typo_text-body')}>{t('ROOM.GALLERY_SETTINGS')}</p>
            <MaxGalleryViewParticipants />
          </div>
        </Hidden>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button variant="primary" label={t('ROOM.DONE')} onClick={onClose}></Button>
      </DialogActions>
    </Dialog>
  );
}
